module.exports = __webpack_public_path__ + "img/rightTxt1.0a88110e.png";